import { useState } from 'react';

// const useHandleDialog = () => {
// const [isCloneDialogOpen, setIsCloneDialogOpen] = useState(false);
// const [isDeleteDilogOpen, setIsDeleteDialogOpen] = useState(false);

// const [newRowData, setNewRowData] = useState('');

// return { isCloneDialogOpen, setIsCloneDialogOpen, newRowData, setNewRowData, isDeleteDilogOpen, setIsDeleteDialogOpen };

const useHandleDialog = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    type: null, // 'clone' | 'delete'
    rowData: null,
  });

  const openDialog = (type, rowData) => {
    setDialogState({ open: true, type, rowData });
  };

  const closeDialog = () => {
    setDialogState({ open: false, type: null, rowData: null });
  };

  return { dialogState, openDialog, closeDialog };
};

export default useHandleDialog;
